import axios from "axios";
import {
  setHeader,
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../options/header";
import { store } from "@/vuex/store";
//poziv express-u da dohvati podatke vezane uz osobu
export default {
  getAll(accessToken) {
    try {
      return axiosGet(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/sharepoint",
        {
          params: {},
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getById(accessToken, groupId) {
    try {
      return axiosGet(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/sharepoint/" +
          groupId,
        {
          params: {},
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },

  searchDriveItems(accessToken, qString) {
    try {
      return axiosGet(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/sharepoint/search/items",
        {
          params: {
            qString,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  getRootDocs(accessToken, groupId) {
    try {
      return axiosGet(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/sharepoint/" +
          groupId +
          "/root",
        {
          params: {},
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  getDocumentsInSpis(accessToken, groupId, sid, smjer) {
    try {
      return axiosGet(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/sharepoint/" +
          groupId +
          "/" +
          sid,
        {
          params: {
            smjer,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  getSingleDoc(accessToken, groupId, sid) {
    try {
      return axiosGet(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/sharepoint/" +
          groupId +
          "/item/" +
          sid,
        {
          params: {},
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  renameSingleDoc(accessToken, groupId, sid, new_name) {
    try {
      return axiosPut(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/sharepoint/" +
          groupId +
          "/item/" +
          sid,
        {
          params: {
            new_name,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  shareSingleDoc(groupId, sid, params_obj) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/sharepoint/" +
          groupId +
          "/items/" +
          sid +
          "/share",
        {
          params: params_obj,
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  addDocumentInSpis(formData) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/file",
        formData
      );
    } catch (err) {
      console.log(err);
    }
  },
  mergeFiles(popis_dl_links, index, file_name) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/file/merge-pdf",
        {
          params: {
            popis_dl_links,
            index,
            file_name,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed to merge documents");
    }
  },
  mergeFilesFinal(index, file_name) {
    try {
      return axios({
        method: "POST",
        url:
          process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/file/merge-pdf-final",
        params: {
          index,
          file_name,
        },
        responseType: "arraybuffer",
        encodeURI: "UTF-8",
        credentials: true,
        headers: setHeader().headers,
      });
    } catch {
      console.log("Failed to merge documents");
    }
  },
  mergeFilesClear(file_name) {
    try {
      return axios({
        method: "POST",
        url:
          process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/file/merge-pdf-clear",
        params: {
          file_name,
        },
        responseType: "arraybuffer",
        encodeURI: "UTF-8",
        credentials: true,
        headers: setHeader().headers,
      });
    } catch {
      console.log("Failed to merge documents");
    }
  },
  createFolderDocs(accessToken, groupId, parent, docname) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/sharepoint/" +
          groupId +
          "/folder",
        {
          params: {
            groupId: groupId,
            parent: parent,
            docname: docname,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  templateFileInit(accessToken, groupId, parent, template_name, docname) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/file/template-create",
        {
          params: {
            groupId: groupId,
            parent: parent,
            docname: docname,
            template_name,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  getTemplateDocs() {
    try {
      return axiosGet(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/file/template",
        {
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  downloadTemplateDoc(docname, extension) {
    try {
      return axios({
        method: "POST",
        url:
          process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/file/template/" +
          docname +
          "/download",
        responseType: "arraybuffer",
        encodeURI: "UTF-8",
        credentials: true,
        headers: setHeader().headers,
        params: {
          extension,
        },
      });
    } catch {
      console.log("Failed to merge documents");
    }
  },
  deleteTemplateDoc(uid) {
    try {
      return axiosDelete(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/file/template/" +
          uid,
        {
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  uploadTemplateDoc(formData) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/file/template",
        formData,
        {
          credentials: true,
        }
      );
    } catch (err) {
      console.log(err);
    }
  },
  updateTemplateDoc(formData, uid) {
    try {
      return axiosPut(
        process.env.VUE_APP_API_ENDPOINT_STARTER +
          "/cases/file/template/" +
          uid,
        formData,
        {
          credentials: true,
        }
      );
    } catch (err) {
      console.log(err);
    }
  },
  // addNewFolder(accessToken,groupId,parent,docname) {
  //   console.log(accessToken);
  //   console.log(groupId);
  //   console.log(parent);
  //   console.log(docname)
  //   try {
  //     return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/sharepoint/folder",  {
  //       params: {
  //
  //         groupId : groupId,
  //         parent : parent,
  //         docname : docname
  //       },
  //       credentials: true,
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // },
  deleteFile(accessToken, groupId, path) {
    try {
      return axiosDelete(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/file",
        {
          params: {
            groupId: groupId,
            path: path,
          },
          credentials: true,
        }
      );
    } catch (err) {
      console.log(err);
    }
  },
  copyFile(accessToken, groupId, itemId, driveItem) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/copy",
        {
          params: {
            groupId: groupId,
            itemId: itemId,
            driveItem: driveItem,
          },
          credentials: true,
        }
      );
    } catch (err) {
      console.log(err);
    }
  },
  convertToPDF(
    accessToken,
    groupId,
    sid,
    path,
    final_name,
    extension,
    logged_uid,
    spis_name
  ) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/file/ms-pdf",
        {
          params: {
            groupId: groupId,
            sid: sid,
            path: path,
            final_name,
            extension,
            logged_uid,
            spis_name,
          },
          credentials: true,
        }
      );
    } catch (err) {
      console.log(err);
    }
  },
  // getFileThumbnails(accessToken, groupId,sid, path) {
  //   try {
  //     return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/file/thumbnails", {
  //       params: {

  //         groupId: groupId,
  //         sid : sid,
  //         path: path,
  //       },
  //        credentials: true
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // },
  moveDriveItem(accessToken, groupId, sid, path, driveItem) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/file/move",
        {
          params: {
            groupId: groupId,
            sid: sid,
            path: path,
            driveItem: driveItem,
          },
          credentials: true,
        }
      );
    } catch (err) {
      console.log(err);
    }
  },
  sendToSign(downloadUrl, groupId, sid) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/file/sign-it",
        {
          params: {
            downloadUrl,
            groupId,
            sid,
          },
          credentials: true,
        }
      );
    } catch (err) {
      console.log(err);
    }
  },

  addNewGroup(accessToken, slucaj) {
    try {
      return axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/sharepoint/",
        {
          params: {
            slucaj: slucaj,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
};
